import {ProductDTO, SelectedProductDTO} from 'grilnica-store-share'
import {ProductItemState} from '../../../ducks/ProductItemDuck'
import PrepareProductEntity from '../../../product/PrepareProductEntity'
import {getSelectedProduct} from '../../combo/getSelectedProduct'

const getSelectProductService = async (product: ProductDTO): Promise<ProductItemState> => {
  const prepareProduct = new PrepareProductEntity(product)

  if (product.productVariants && product.productVariants?.length !== 0) {
    prepareProduct.createProductVariantMap()
  }

  if (product.optionCategories) {
    for (let optionCategory of product.optionCategories) {
      prepareProduct.sortOptionCategoryByType(optionCategory)
      prepareProduct.addSelectedOptionsInMaps(optionCategory)
      prepareProduct.addOptionCategoryInMap(optionCategory)
      prepareProduct.createOptionMap(optionCategory)
    }
  }
  prepareProduct.addSelectedProductPriceAndProductVariant()

  let newSelectedProduct: SelectedProductDTO = getSelectedProduct(
    prepareProduct.getSelectedProduct(),
    prepareProduct.getSelectedOptionsMap(),
    prepareProduct.getOptionMap(),
    prepareProduct.getOptionCategoryMap(),
    prepareProduct.getRestrictionsMap(),
  )

  return {
    products: null,
    productsByProductIdMap: null,
    supportsMaps: {
      countSelectedOptionsMap: prepareProduct.getCountSelectedOptionsMap(),
      optionCategoryMap: prepareProduct.getOptionCategoryMap(),
      optionCategoryTypeMap: prepareProduct.getOptionCategoryTypeMap(),
      optionMap: prepareProduct.getOptionMap(),
      optionProductMap: prepareProduct.getOptionProductMap(),
      productVariantMap: prepareProduct.getProductVariantMap(),
      restrictionsMap: prepareProduct.getRestrictionsMap(),
      selectedOptionsMap: {...prepareProduct.getSelectedOptionsMap()},
      extraOptionsMap: {},
    },
    selectedProduct: newSelectedProduct,
    restaurantByProductMap: null,
  }
}

export {getSelectProductService}
